/* src/app/components/article-option-group-checkbox/article-option-group-checkbox.component.scss */
ion-radio-group {
  width: 100%;
  border-radius: 0px;
  padding: 5px;
  display: block;
}
.price {
  font-size: 14px;
  font-weight: bold;
  color: var(--color-black);
}
ion-label {
  font-size: 14px;
}
@media (min-width: 991px) {
  ion-label {
    padding-right: 5px;
  }
}
ion-icon {
  color: var(--ion-color-primary);
  height: 20px;
  width: 20px;
}
app-tag {
  display: inline-block;
}
ion-item {
  --background: #F6F1EF;
  background: #F6F1EF;
  margin: 10px 10px;
  --inner-padding-end: 2px;
  padding: 0px 10px;
  border-radius: 26px;
  border: 1px solid transparent;
}
.item-img {
  width: 50px;
  padding: 7px;
}
ion-checkbox::part(container) {
  background-size: contain;
  border-radius: 50%;
  border-color: var(--border-color-checked);
}
ion-checkbox.checkbox-checked::part(container) {
  border-radius: 50%;
}
ion-checkbox {
  --checkbox-background: #F6F1EF;
  --border-color-checked: var(--color-black);
  --checkbox-background-checked: transparent;
  height: 20px;
  width: 20px;
}
.text_wrap {
  text-align: left;
  text-wrap: wrap;
  white-space: normal;
  word-break: break-word;
}
.text_wrap span {
  color: #1A1A18 !important;
  display: flex;
  letter-spacing: -0.5px;
}
.mehr-articles {
  width: fit-content;
}
.mehr-articles div {
  background: white;
  border: 1px solid black;
  padding: 5px 10px;
  border-radius: 25px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.mehr-articles div h3 {
  margin-right: 20px;
}
.mehr-articles div ion-icon {
  color: black;
  margin-left: 15px;
  rotate: 0deg;
  transition: rotate 0.7s;
}
.mehr-articles div ion-icon.rotate {
  rotate: 180deg;
}
.hidden {
  visibility: hidden;
}
.qty {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100px;
}
.qty__btn {
  width: 20px;
  height: 20px;
  margin: 0 !important;
  box-shadow: none;
  --box-shadow: none;
}
.qty__btn button {
  box-shadow: unset !important;
}
.qty__btn span {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  color: white;
  line-height: 16px;
}
.qty .qty-number {
  margin: 0 4px;
  text-align: center;
  min-width: 15px;
  color: var(--color-black);
}
.qty .qty-number.zero {
  color: transparent;
}
ion-toggle {
  --handle-background-checked: var(--primary-btn);
}
/*# sourceMappingURL=article-option-group-checkbox.component.css.map */
